module.exports = __webpack_public_path__ + "img/bag.af9342ce.png";